	/**
	* Interacts with the IJSF methods on: engagement, interaction, agent chat messages and customer chat messages
	* @author Fred A. Pinn
	*/
/**
 * package: com.inq.flash.client.control
 * class: Incrementality
 * root Object
 * @constructor
 */
com.inq.flash.client.control.Incrementality = function() {};
/** @private @type {Array} */
com.inq.flash.client.control.Incrementality.__name__ = ["com","inq","flash","client","control","Incrementality"];
/** @type {?boolean} */
com.inq.flash.client.control.Incrementality.interacted = null;

/**
 * init
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function init()
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.control.Incrementality.init = function() {
	com.inq.flash.client.control.Incrementality.interacted = com.inq.flash.client.control.PersistenceManager.GetValue(CHAT_INTERACTED, false);
	return true;
};


/**
 * onEngaged
 * The user has engaged by typing text in the input field
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function onEngaged():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.control.Incrementality.onEngaged = function() {
	Application.application.applicationController.skinControl.StopTimer();
	if(com.inq.flash.client.control.FlashPeer.isPersistentWindow()) {
		return;
	}
	if(com.inq.flash.client.control.FlashVars.getFlashVars().brID == "") return;
	com.inq.flash.client.control.FlashPeer.onEngaged({ brID : com.inq.flash.client.control.FlashVars.getFlashVars().brID});
	var startTimerDate = new Date();
	com.inq.flash.client.chatskins.SkinControl.closeChatOneHourTimer(startTimerDate);
	Application.application.fireMxmlEvent("onEngaged");
	haxe.Log.trace("Incrementality.onEngaged",{ fileName : "Incrementality.hx", lineNumber : 28, className : "com.inq.flash.client.control.Incrementality", methodName : "onEngaged"});
};


/**
 * onInteracted
 * The user has established a dialog with the agent and the agent has responded
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function onInteracted():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.control.Incrementality.onInteracted = function() {
	try {
		/** @type {boolean} */
		var bInteracted = false;
		try {
			bInteracted = com.inq.flash.client.control.Incrementality.interacted;
		} catch( e ) {
		}
		if(bInteracted) return;
		com.inq.flash.client.control.Incrementality.interacted = true;
		com.inq.flash.client.control.PersistenceManager.SetValue(CHAT_INTERACTED, com.inq.flash.client.control.Incrementality.interacted);
		if (com.inq.flash.client.control.FlashPeer.isPersistentWindow() && !(Application.application.applicationController.skinControl.isClick2call() || com.inq.flash.client.control.FlashPeer.isV3C2CPersistent())) {
			return;
		}
		if(com.inq.flash.client.control.FlashVars.getFlashVars().brID == "") return;

		com.inq.flash.client.control.FlashPeer.onInteracted({ brID : com.inq.flash.client.control.FlashVars.getFlashVars().brID});
		Application.application.fireMxmlEvent("onInteracted");
		haxe.Log.trace("onInteracted",{ fileName : "Incrementality.hx", lineNumber : 50, className : "com.inq.flash.client.control.Incrementality", methodName : "onInteracted"});
	} catch( e ) {
		haxe.Log.trace("onInteracted failed: " + Std.string(e),{ fileName : "Incrementality.hx", lineNumber : 52, className : "com.inq.flash.client.control.Incrementality", methodName : "onInteracted"});
	}
};


/**
 * onAgentMsg
 * The agent has sent a message
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function onAgentMsg():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.control.Incrementality.onAgentMsg = function(chatData) {
	if(com.inq.flash.client.control.FlashVars.getFlashVars().brID == "") return;
	com.inq.flash.client.control.FlashPeer.onAgentMsg({ brID : com.inq.flash.client.control.FlashVars.getFlashVars().brID,textLine : chatData == null?"":chatData});
	Application.application.fireMxmlEvent("onAgentMsg");
	haxe.Log.trace("onAgentMsg",{ fileName : "Incrementality.hx", lineNumber : 63, className : "com.inq.flash.client.control.Incrementality", methodName : "onAgentMsg"});
};

/**
 *	Fires agentDataPassEvent event.
 *
 *	@param {string} agentDataPass - agentDataPass value of the agent message.
 */
com.inq.flash.client.control.Incrementality.onAgentDataPass = function (agentDataPass) {
	com.inq.flash.client.control.FlashPeer.onAgentDataPass(agentDataPass);
	Application.application.fireMxmlEvent("onAgentDataPass");
	haxe.Log.trace("onAgentDataPass", {
		fileName: "Incrementality.js",
		className: "com.inq.flash.client.control.Incrementality",
		methodName: "onAgentDataPass"
	});
};

/**
 *	Saves vaDataPass and fires vaDataPassEvent event.
 *
 *	@param {string} vaDataPass - vaDataPass value of the virtual agent message.
 */
com.inq.flash.client.control.Incrementality.onVADataPass = function (vaDataPass) {
	com.inq.flash.client.control.FlashPeer.onVADataPass(vaDataPass);
	Application.application.fireMxmlEvent("onVADataPass");
	com.inq.flash.client.control.FlashPeer.debugLogInfoToTagServer(
		"VA_DATA_PASS",
		"onVADataPass received: " + vaDataPass
	);
};

	/**
	 * a ChatAuthorizedMessage confirms chatroom is created on a ChatRouter and a datapass can be sent with customer id without an agent id.
	 * @see com.inq.flash.client.control.messagehandlers.ChatAuthorizedMessageHandler.prototype.processMessage
	 */
	com.inq.flash.client.control.Incrementality.onChatroomReady = function() {
		if (!com.inq.flash.client.control.FlashVars.getFlashVars().brID) {
			return;
		}
		com.inq.flash.client.control.FlashPeer.onChatroomReady({
			brID: com.inq.flash.client.control.FlashVars.getFlashVars().brID
		});
		Application.application.fireMxmlEvent("onChatroomReady");
		haxe.Log.trace("onChatroomReady", {
			fileName: "Incrementality.js"
		});
	};


/**
 * onCustomerMsg
 * The customer has sent a message
 *
 * $type TFun([{ name => chatData, t => TInst(String,[]), opt => true }],TEnum(Void,[]))
 * public static function onCustomerMsg(?chatData:String):Void
 * @public
 * @static
 * @param {string}  chatData
 * @return {void}
 */
com.inq.flash.client.control.Incrementality.onCustomerMsg = function(chatData) {
	if(com.inq.flash.client.control.FlashVars.getFlashVars().brID == "") return;

	/** @type {Object} */
	var eventData = {"textLine": chatData == null ? "" : chatData};
	com.inq.flash.client.control.FlashPeer.onCustomerMsg(eventData);
	Application.application.fireMxmlEvent("onCustomerMsg");
	haxe.Log.trace("onCustomerMsg",{ fileName : "Incrementality.hx", lineNumber : 75, className : "com.inq.flash.client.control.Incrementality", methodName : "onCustomerMsg"});
};


/**
 * onAssisted for click to call only since for click to chat called in onCustomerMsg and onAgentMsg when criteria has been satisfied
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function onAssisted():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.control.Incrementality.onAssisted = function() {
	if(com.inq.flash.client.control.FlashVars.getFlashVars().brID == "") return;
	com.inq.flash.client.control.FlashPeer.onAssisted({ brID : com.inq.flash.client.control.FlashVars.getFlashVars().brID});
	Application.application.fireMxmlEvent("onAssisted");
	haxe.Log.trace("onAssisted",{ fileName : "Incrementality.hx", lineNumber : 85, className : "com.inq.flash.client.control.Incrementality", methodName : "onAssisted"});
};

/** @type {com.inq.flash.client.control.Incrementality} */
com.inq.flash.client.control.Incrementality.prototype.__class__ = com.inq.flash.client.control.Incrementality;
